/**
 * Host override bags (ticks, file uploads) can arrive in two steps when
 * SprintDetail stays mounted across campaign tabs: first a stub mission
 * (empty bags), then the real task. Apply identity resets and late hydrates,
 * but ignore stale props while our own write hasn't echoed yet.
 */
export function shouldApplyHostOverrides({
  identityChanged,
  incomingEqualsLastPushed,
  incomingEqualsLocal,
  pendingEcho,
}) {
  if (identityChanged) return { apply: true, clearPending: true };
  if (incomingEqualsLastPushed) return { apply: false, clearPending: true };
  if (incomingEqualsLocal || pendingEcho) return { apply: false, clearPending: false };
  return { apply: true, clearPending: true };
}
